import styled from 'styled-components';

export const AppContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;
